import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { getDynamicPageById } from '../../services'
import { DynamicPageQueryKeys } from '@/modules/client-setting/keys'
import {
	GetDynamicPageByIdPayload,
	GetDynamicPageByIdResponse,
} from '@/modules/client-setting/type'

export default function useQueryGetDynamicPageById(
	id: string,
	payload: GetDynamicPageByIdPayload,
	props?: UseBaseQueryOptions<GetDynamicPageByIdResponse>,
) {
	return useQuery({
		queryKey: [DynamicPageQueryKeys.GetDynamicPageById, id, payload],
		queryFn: () => getDynamicPageById(id, payload),
		...props,
	})
}
